<template>
  <div class="v-batch-operation">
    <!-- 1. 选中数量与状态胶囊 -->
    <div class="deck-count-pill">
      <v-icon small color="#0d9488">mdi-checkbox-marked-circle-outline</v-icon>
      <span class="count-text">已选 <b>{{ selectedCards.length }}</b> 项</span>
    </div>

    <div class="deck-divider"></div>

    <!-- 2. 主操作：批量下载 -->
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <button class="deck-action-btn btn-download" v-bind="attrs" v-on="on" @click="on_batch_operation('download')">
          <v-icon small color="#fff" class="mr-1">mdi-download</v-icon>
          <span>批量下载</span>
        </button>
      </template>
      <span>下载已选素材</span>
    </v-tooltip>

    <!-- 3. 点赞与不喜欢 -->
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <button class="deck-icon-btn" v-bind="attrs" v-on="on" @click="on_batch_operation('like')">
          <v-icon small color="#0f766e">mdi-thumb-up-outline</v-icon>
        </button>
      </template>
      <span>批量点赞</span>
    </v-tooltip>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <button class="deck-icon-btn" v-bind="attrs" v-on="on" @click="on_batch_operation('dislike')">
          <v-icon small color="#64748b">mdi-emoticon-sad-outline</v-icon>
        </button>
      </template>
      <span>批量不喜欢</span>
    </v-tooltip>

    <div class="deck-divider"></div>

    <!-- 4. 全选与清空 -->
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <button class="deck-icon-btn" v-bind="attrs" v-on="on" @click="selectAll">
          <v-icon small color="#0f766e">mdi-checkbox-multiple-marked-outline</v-icon>
        </button>
      </template>
      <span>全选当前页</span>
    </v-tooltip>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <button class="deck-icon-btn btn-close" v-bind="attrs" v-on="on" @click="handleDeselect">
          <v-icon small color="#94a3b8">mdi-close</v-icon>
        </button>
      </template>
      <span>取消全部选择</span>
    </v-tooltip>

    <div class="deck-status" v-if="statusText">{{ statusText }}</div>
  </div>
</template>
      <span>批量下载</span>
    </v-tooltip>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="like" text icon v-bind="attrs" v-on="on" @click="on_batch_operation('like')">
          <v-icon>mdi-thumb-up-outline</v-icon>
        </v-btn>
      </template>
      <span>点赞</span>
    </v-tooltip>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="dislike" text icon v-bind="attrs" v-on="on" @click="on_batch_operation('dislike')">
          <v-icon>mdi-emoticon-sad-outline</v-icon>
        </v-btn>
      </template>
      <span>不喜欢</span>
    </v-tooltip>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="select-all" text icon v-bind="attrs" v-on="on" @click="selectAll">
          <v-icon>mdi-checkbox-multiple-marked</v-icon>
        </v-btn>
      </template>
      <span>全选</span>
    </v-tooltip>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="deselect" text icon v-bind="attrs" v-on="on" @click="handleDeselect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
      <span>取消选择</span>
    </v-tooltip>
    <p class="checked-amount" :class="{ 'indicator-active': selectedCards.length >= 1 }">
      {{ selectedCards.length }}
    </p>
    <div class="status">{{ statusText }}</div>
  </div>
</template>

<script>
import { get_api_data } from "@/utils/ajax";
import { download_single } from "@/utils/util";
import { mapState, mapMutations } from "vuex";

export default {
  name: "v-batch-operation",
  computed: {
    ...mapState("global", ["allCardList"]),
    ...mapState("batchOperation", ["selectedCards", "checkedAmount"]),
    isAllSelected() {
      const selectableCards = this.allCardList.filter(
        card => card.is_qualified !== -1
      );
      return selectableCards.length > 0 &&
             this.selectedCards.length === selectableCards.length;
    }
  },
  data() {
    return {
      downloadQueue: [],
      totalDownloadCount: 0,
      isDownloading: false,
      totalTasks: 0,
      statusText: '等待操作...',
    };
  },
  mounted() {
    console.log('v-batch-operation mounted. Element:', this.$el);
  },
  methods: {
    ...mapMutations("batchOperation", [
      "addSelectedCards",
      "delSelectedCards",
      "delAllSelectedCards",
    ]),
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    updateStatus(text) {
      this.statusText = text;
      console.log('Status updated:', text);
    },
    async on_batch_operation(type) {
      let args = {};
      let apiName = "";

      const batch_task = (item) => {
        return () => {
          return update_api(item);
        };
      };

      const update_api = (item) => {
        switch (type) {
          case "download":
            args = { fileIds: [item.fileId] };
            apiName = `${type}s`;
            break;
          case "like":
            args = { fileIds: [item.fileId], action: "inc" };
            apiName = type;
            break;
          case "dislike":
            args = { fileIds: [item.fileId], action: "inc" };
            apiName = type;
            break;
        }
        return get_api_data("POST", `materials/${apiName}`, args).then(() => {
          // 移除卡片选中状态，但不直接从 selectedCards 中移除
          $(".card-post-img")
            .eq(item.index)
            .removeClass("card-selected")
            .find(".form-check-input")
            .get(0).checked = false;
          this.allCardList[item.index][`${type}s`]++;
          this.$P.$emit("download_all_input_checked", args.fileIds[0]);
        });
      };

      if (type === "download") {
        if (this.selectedCards.length === 0) {
          this.updateStatus('未找到选中的项目！请先选择项目。');
          return;
        }
        this.totalTasks += this.selectedCards.length;
        this.downloadQueue = [...this.selectedCards];
        this.updateStatus(
          `队列任务: ${this.downloadQueue.length} 个，总计: ${this.totalDownloadCount}/${this.totalTasks}`
        );
        await this.processDownloadQueue();
      } else {
        let arrBatchTask = [];
        this.selectedCards.map((item) => {
          arrBatchTask.push(batch_task(item));
        });
        for (let i = 0; i < arrBatchTask.length; i++) {
          await arrBatchTask[i]();
        }
        this.delAllSelectedCards();
      }
    },
    async processDownloadQueue() {
      if (this.isDownloading || this.downloadQueue.length === 0) return;
      this.isDownloading = true;
      let errors = [];
      const itemsToProcess = [...this.downloadQueue];
      while (this.downloadQueue.length > 0) {
        const item = this.downloadQueue.shift();
        this.totalDownloadCount++;
        this.updateStatus(
          `队列剩余: ${this.downloadQueue.length} 个，总计: ${this.totalDownloadCount}/${this.totalTasks}`
        );
        console.log(
          `--- 处理第 ${this.totalDownloadCount}/${this.totalTasks} 个项目 ---`
        );
        try {
          await get_api_data("POST", `materials/downloads`, { fileIds: [item.fileId] });
          window.open(item.download_url, "_self");
          $(".card-post-img")
            .eq(item.index)
            .removeClass("card-selected")
            .find(".form-check-input")
            .get(0).checked = false;
          this.allCardList[item.index].downloads++;
          this.$P.$emit("download_all_input_checked", item.fileId);
          console.log(`成功下载文件 ID: ${item.fileId}。等待 4500ms...`);
          await this.delay(4500);
        } catch (e) {
          const errorMsg = `下载文件 ID: ${item.fileId} 出错: ${e.message}`;
          console.error(errorMsg);
          errors.push(errorMsg);
          await this.delay(4500);
        }
      }
      itemsToProcess.forEach((item) => {
        this.delSelectedCards(item);
      });
      let finalMessage = `下载完成，总计: ${this.totalDownloadCount}/${this.totalTasks}`;
      if (errors.length > 0) finalMessage += `，本次错误: ${errors.length}`;
      
      this.downloadQueue = [];
      this.totalDownloadCount = 0;
      this.totalTasks = 0;
      this.isDownloading = false;
      finalMessage += '，队列已清空';
      this.updateStatus(finalMessage);
    },
    handleDeselect() {
      console.log('开始取消所有勾选...');
      if (this.selectedCards.length === 0) {
        this.updateStatus('当前没有选中的项目！');
        console.log('没有找到需要取消勾选的项目。');
        return;
      }
      const selectedCount = this.selectedCards.length;
      this.delAllSelectedCards();
      $(".card-post-img.card-selected").each((index, element) => {
        $(element)
          .removeClass("card-selected")
          .find(".form-check-input")
          .get(0).checked = false;

        // 触发 mouseleave 事件来隐藏 .item-info
        const cardBox = $(element).find('.card-post-img-box').get(0);
        if (cardBox) {
          const mouseleaveEvent = new MouseEvent('mouseleave', {
            bubbles: true,
            cancelable: true
          });
          cardBox.dispatchEvent(mouseleaveEvent);
        }

        console.log(`已取消第 ${index + 1} 个项目的勾选`);
      });
      this.downloadQueue = [];
      this.totalDownloadCount = 0;
      this.totalTasks = 0;
      this.isDownloading = false;
      this.updateStatus(`已取消 ${selectedCount} 个项目的勾选，队列已清空`);
      console.log(`完成取消 ${selectedCount} 个项目的勾选`);
    },
    selectAll() {
      console.log('开始全选...');
      let selectedCount = 0;

      this.allCardList.forEach((cardData, index) => {
        if (cardData.is_qualified === -1) return;

        const alreadySelected = this.selectedCards.some(
          item => item.fileId === cardData.fileId
        );
        if (alreadySelected) return;

        const data = {
          download_url: cardData.download_url,
          fileId: cardData.fileId,
          index: index
        };

        this.addSelectedCards(data);
        selectedCount++;

        const cardElement = $('.card-post-img').eq(index);
        cardElement.addClass('card-selected');

        // 触发 mouseenter 强制 Vue 渲染 checkbox
        const cardBox = cardElement.find('.card-post-img-box').get(0);
        if (cardBox) {
          const mouseenterEvent = new MouseEvent('mouseenter', {
            bubbles: true,
            cancelable: true
          });
          cardBox.dispatchEvent(mouseenterEvent);
        }

        // 等待 Vue 渲染后设置 checkbox
        setTimeout(() => {
          const checkbox = cardElement.find('.form-check-input').get(0);
          if (checkbox) checkbox.checked = true;
        }, 10);
      });

      this.updateStatus(`已选中 ${selectedCount} 个项目`);
      console.log(`全选完成，共选中 ${selectedCount} 个项目`);
    },
  },
};
</script>

<style scoped lang="scss">
.v-batch-operation {
  position: fixed;
  left: 50%;
  bottom: 28px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1.5px solid rgba(16, 185, 129, 0.4);
  box-shadow: 0 16px 36px -6px rgba(13, 148, 136, 0.28),
              0 4px 14px -2px rgba(15, 23, 42, 0.08);
  z-index: 1000;
  animation: deckSlideUp 0.32s cubic-bezier(0.16, 1, 0.3, 1);

  .deck-count-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 20px;
    background: #f0fdfa;
    border: 1px solid rgba(13, 148, 136, 0.2);

    .count-text {
      font-size: 13px;
      color: #0f766e;
      font-weight: 500;

      b {
        font-weight: 700;
        color: #0d9488;
        font-size: 14px;
      }
    }
  }

  .deck-divider {
    width: 1px;
    height: 22px;
    background: #e2e8f0;
    margin: 0 2px;
  }

  .deck-action-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 34px;
    padding: 0 14px;
    border-radius: 999px;
    border: none;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    outline: none;

    &.btn-download {
      background: linear-gradient(135deg, #10b981 0%, #0d9488 100%);
      color: #ffffff;
      box-shadow: 0 4px 12px rgba(13, 148, 136, 0.35);

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(13, 148, 136, 0.48);
        filter: brightness(1.05);
      }

      &:active {
        transform: translateY(1px);
      }
    }
  }

  .deck-icon-btn {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: 1px solid transparent;
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    outline: none;

    &:hover {
      background: #f0fdfa;
      border-color: rgba(16, 185, 129, 0.3);
      transform: scale(1.1);
    }

    &:active {
      transform: scale(0.95);
    }

    &.btn-close:hover {
      background: #fef2f2;
      border-color: rgba(239, 68, 68, 0.3);
      .v-icon {
        color: #ef4444 !important;
      }
    }
  }

  .deck-status {
    margin-left: 6px;
    background: #f0fdfa;
    color: #065f46;
    border: 1px solid rgba(16, 185, 129, 0.25);
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
  }
}

@keyframes deckSlideUp {
  from {
    opacity: 0;
    transform: translate(-50%, 18px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

@media (max-width: 600px) {
  .v-batch-operation {
    bottom: 20px;
    padding: 4px 10px;
    .deck-count-pill {
      padding: 3px 6px;
      .count-text { font-size: 12px; }
    }
    .deck-action-btn {
      padding: 0 10px;
      height: 30px;
      font-size: 12px;
    }
    .deck-icon-btn {
      width: 30px;
      height: 30px;
    }
  }
}
</style>